import ACTIONS from 'application/constants'

export const openAkteSidebar = (key) => ({
    type: ACTIONS.PAGES_AKTEN_OPEN_AKTE_SIDEBAR,
    key
})

export const closeAkteSidebar = () => ({
    type: ACTIONS.PAGES_AKTEN_CLOSE_AKTE_SIDEBAR,
})